import { IconProps } from "./IconProps";

export function InfoCircle(props: IconProps) {
  const { size = 24, className, color = "currentColor", ...svgProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill={color}
      className={className}
      width={size}
      height={size}
      {...svgProps}
    >
      <path
        fillRule="evenodd"
        d="M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16 16-7.2 16-16S24.8 0 16 0zm2 13v13h-4V13h4zm0-2V6h-4v5h4z"
        clipRule="evenodd"
      />
    </svg>
  );
}
